// extracted by mini-css-extract-plugin
export default {"productDescription":"b3-z","featuredDescription":"c3-z","description":"d3-z","more":"e3-z","brandLogo":"f3-z","descriptionSku":"g3-z"};